<template>
    <!-- banner -->
        <div class="home-banner ">
            <div class="banner-cont">
                <div class="banner-search" :class="isShowAi?'':'no-ai'"> 
                    <div class="search-cont" >
                        <el-input class="search-input" @keyup.enter.native="search_click" v-model="searchVal" placeholder="请输入内容"></el-input> 
                        <div class="search-btn ">
                            <div class="ai-btn" @click="search_click">
                                <span class="icon search-icon"></span>
                                <span class="search-txt" >搜索</span> 
                            </div>
                        </div>
                    </div>
                    <div v-if='isShowAi' class="search-btn">
                        <div class="ai-btn" @click="toPage('aiAnswer','')">
                            <span class="icon search-icon"></span>
                            <span  class="search-txt" >AI问答</span>  
                        </div>
                    </div> 
                </div>
                <div class="search-hot">大家都在搜：
                    <span v-for="(item,index) in wordList" :key="index" @click="toPage('globalHotWord',item.val)">{{item.val}}</span>
                </div>
            </div> 
        </div>
</template>

<script> 
export default {
    props: {
        isShowAi:{
            type: Boolean,
            default:true
        },
        isNewPage:{
            type: Boolean,
            default:true
        },
        // 热搜词列表，可传入覆盖；不传则使用默认值
        wordList: {
            type: Array,
            default() {
                return [
                    { val: '大黄' },
                    { val: '人参' },
                    { val: '中风' },
                    { val: '咳喘' },
                ]
            }
        },
    },
    components: {},
    data() {
        return {
            searchVal:this.$route.query.word||'',
        }
    },
    watch: {},
    mounted() { 
    },
    methods: {
        toPage(path,word){    
            let query={
                word,
            };
            //  console.log(this.isNewPage,'==isNewPage')
            // return
            //如果是在二级检索页，点击热搜词，重新调用搜索方法；不需要打开新页面；
            if(this.$route.path=='/globalHotWord'&&path=='globalHotWord'){
            // if(!this.isNewPage){
                this.searchVal=word;
                this.search_click(); 
                return
            }
            let url= this.$router.resolve({
                path,
                query,
            }) 
            this.$windowOpen({ url:url.href,isLogin:path=='aiAnswer'?true:false} )
        },
        search_click(){
            // console.log(this.isNewPage,'==isNewPage')
            // return
            if(!this.searchVal){
                this.$message.warning('请输入检索内容～')
                return
            }
            //如果是在二级检索页，就调用对应的页面的banner_search，如果在其他页面就跳转到globalHotWord页面 this.$route.path !='/globalHotWord'
            if(this.isNewPage){
                this.toPage('globalHotWord',this.searchVal) 
            }else{
                this.$emit('banner_search',this.searchVal) 
            }
        },
        clear_search(){
            this.searchVal='';
        }
    }
}
</script>
<style lang='less' scoped>
.home-banner{
    width: 100%;
    height: 340px;
    background: url('../../assets/images/home/banner-bg.png') no-repeat center;
    background-size: cover;
    .banner-cont{
        width: 940px;
        margin: 0 auto ;
        padding-top:122px;
        .banner-search{ 
            display: flex;
            justify-content: space-between;
            .search-cont{
                width: 780px;
                height: 56px;
                display: flex;
                border-radius: 12px;
                overflow: hidden; 
                .search-btn{
                    width: 130px;
                    border-radius: 0;
                }
            }
            .search-input{
                width: 648px; 
                &.cont-w{
                    width: 868px;
                }

            }
            &.no-ai{
                .search-cont{
                     width: 1000px;
                }
                .search-input{
                    width: 868px;
                }

            }
            ::v-deep .el-input__inner{ 
                height:  56px;
                background:rgba(255, 255, 255, .9);
                border-radius: 12px 0 0 12px;  
                color: #396de7;
                font-weight: bold;
                font-size: 16px;
                &::-webkit-input-placeholder{
                    -webkit-text-fill-color: #a6a6a6;;
                }
                &::-moz-placeholder {
                    color:  #a6a6a6;; /* 例如：color: #FF0000; */
                }
                &:-ms-input-placeholder {
                    color:  #a6a6a6;;  /* 例如：color: #FF0000; */
                }
                    
                &:-moz-placeholder {
                    color:  #a6a6a6;;  /* 例如：color: #FF0000; */
                }
            } 
            .search-btn{ 
                background-color: #ffffff;
                // border-radius: 12px;
                width: 135px;
                height: 56px; 
                line-height: 56px;
                border-radius: 12px;
                cursor: pointer;
                .ai-btn{
                    display: flex;
                    align-items: center;
                    justify-content: center
                }
                .icon{ 
                    width: 24px;
                    height: 24px; 
                    margin-right: 10px;
                }
                .search-icon{
                    background: url('../../assets/images/home/search-icon.png') no-repeat;
                    background-size: contain;
                }
                .ai-icon{ 
                    background: url('../../assets/images/home/ai-icon.png') no-repeat;
                    background-size: contain;
                }
                .search-txt{
                    background-image: linear-gradient(
                        270deg,
                        rgba(129, 255, 217, 1) 0,
                        rgba(103, 238, 255, 1) 11.146801%,
                        rgba(70, 180, 255, 1) 33.139325%,
                        rgba(22, 93, 255, 1) 100%
                        ); 
                        overflow-wrap: break-word;
                        color: rgba(22, 93, 255, 1);
                        font-size: 18px;
                        font-family: PingFang-SC-Medium;
                        font-weight: normal;
                        text-align: left;
                        white-space: nowrap; 
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent; 
                }
            }
            
        } 
        .search-hot{
            margin-top: 22px;
            color: #fff;
            font-weight: bold;
            span{
                margin :0  10px;
                cursor: pointer;
            }
        }
        
    }
}
</style>
